import { Box, Button, Dialog, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { FC, useState } from 'react';

interface Props {
    title?: string
    message?: string
    processing?: boolean
    errorMessage?: string | null
    onConfirm: (pin: string) => void
    close: () => void
}
interface StateProps {
    pin: string
}
const ConfirmPinDialog: FC<Props> = ({
    title,
    message,
    processing,
    errorMessage,
    onConfirm,
    close
}) => {
    const [state, setState] = useState<StateProps>({ pin: '' })
    const { pin } = state

    const submit = () => {
        if (pin && !processing)
            onConfirm(pin)
    }

    return (
        <Dialog
            open
            onClose={close}
            PaperProps={{
                sx: {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
            }}
            slotProps={{
                backdrop: {
                    sx: {
                        backdropFilter: 'none',
                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    },
                    onClick: close,
                },
            }}
        >
            <Box sx={{
                bgcolor: '#fff',
                width: 320,
                p: 3,
                borderRadius: 2
            }}>
                <Typography sx={{ fontWeight: 'bold', mb: 1 }}>{title || 'Enter PIN'}</Typography>
                <Typography sx={{ fontSize: 13, color: '#666', mb: 2.5 }}>
                    {message || 'Enter your PIN to confirm this transaction.'}
                </Typography>
                <TextField
                    fullWidth
                    autoFocus
                    type="password"
                    label="PIN"
                    value={pin}
                    inputProps={{ inputMode: 'numeric', maxLength: 6 }}
                    onChange={e => setState({ pin: e.target.value.replace(/\D/g, '') })}
                    onKeyDown={e => { if (e.key === 'Enter') submit() }}
                    error={Boolean(errorMessage)}
                    helperText={errorMessage}
                />
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mt: 3
                }}>
                    <Button
                        onClick={close}
                        disabled={processing}
                        sx={{ textTransform: 'none' }}
                        variant={'outlined'}
                        color={'inherit'}
                    >Cancel</Button>
                    <LoadingButton
                        onClick={submit}
                        loading={processing}
                        disabled={!pin}
                        variant={'contained'}
                        sx={{ textTransform: 'none' }}
                    >Confirm</LoadingButton>
                </Box>
            </Box>
        </Dialog>
    )
}

export default ConfirmPinDialog
